import { mapState } from 'vuex';
import baseApiAddress from '@/axios.config';

export default {
    computed: {
        ...mapState('notificationStore', {
            notificationData: (state) => state.notificationData,
            notificationItems: (state) => state.notificationItems,
        }),
    },
    methods: {
        async getPaginationData() {
            const notificationContainer = this.$refs.notificationContainer;
            const { scrollTop, clientHeight, scrollHeight } = notificationContainer;
            if (scrollTop + clientHeight === scrollHeight) {

                if (this.notificationData.next_page_url) {
                    try {
                        const { data, status } = await baseApiAddress({
                            method: 'get',
                            url: `${this.notificationData.next_page_url}`,
                        });
                        if (status >= 200 && status < 300) {
                            this.$store.commit(
                                'notificationStore/SET_NOTIFICATION_DATA',
                                data.data
                            );
                            this.$store.commit('notificationStore/PAGINATION_DATA', data.data.data);
                            this.$store.commit('SET_LOADING', false)
                        }
                    } catch (error) { }
                }
            }
        },
    },
};
